import { createElement, forwardRef } from 'react';
import { stack } from '../patterns/stack.js';
import { splitProps } from '../helpers.js';
import { styled } from './factory.js';

export const Stack = /* @__PURE__ */ forwardRef(function Stack(props, ref) {
  const [patternProps, restProps] = splitProps(props, stack.propKeys)
  const styleProps = stack.raw(patternProps)
  const mergedProps = { ref, ...styleProps, ...restProps }
  return createElement(styled["div"], mergedProps)
})